module.exports = __webpack_public_path__ + "static/media/onza.4ff0ade8.webp";